/**
 * Announcement bar height, sticky flag, and fade slider.
 * Loaded from sections/announcement-bar.liquid as type="module".
 */

const SELECTOR = '[data-section-type="announcement-bar"]'

function initFadeSlider(root) {
  const slider = root.querySelector('[data-slider]')
  const slides = [...(slider || root).querySelectorAll('[data-slide]')]
  if (!slider || slides.length < 2) {
    slides[0]?.classList.add('swiper-slide-active', 'swiper-slide-visible')
    return
  }

  let index = 0
  let timer = null
  const delay = parseInt(slider.dataset.autoplayDelay || '5000', 10)
  const autoplay = slider.dataset.autoplayEnabled === 'true'
  const prevButtons = root.querySelectorAll('.slider-nav-button-prev')
  const nextButtons = root.querySelectorAll('.slider-nav-button-next')

  function show(nextIndex) {
    index = (nextIndex + slides.length) % slides.length
    slides.forEach((slide, i) => {
      const active = i === index
      slide.classList.toggle('swiper-slide-active', active)
      slide.classList.toggle('swiper-slide-visible', active)
      slide.toggleAttribute('inert', !active)
      slide.style.opacity = active ? '1' : '0'
    })
  }

  function start() {
    stop()
    if (!autoplay) return
    timer = window.setInterval(() => show(index + 1), delay)
  }

  function stop() {
    if (timer) window.clearInterval(timer)
    timer = null
  }

  slides.forEach((slide) => {
    slide.style.transition = 'opacity 0.4s ease'
  })
  root.classList.add('slider-active')
  slider.classList.add('swiper-initialized')
  show(0)
  start()

  prevButtons.forEach((button) =>
    button.addEventListener('click', () => {
      show(index - 1)
      start()
    })
  )
  nextButtons.forEach((button) =>
    button.addEventListener('click', () => {
      show(index + 1)
      start()
    })
  )
}

function init(root) {
  if (root.dataset.abInit) return
  root.dataset.abInit = 'true'

  const setHeight = () => {
    document.documentElement.style.setProperty('--announcement-height', `${root.offsetHeight}px`)
  }
  document.documentElement.setAttribute(
    'data-enable-sticky-announcement-bar',
    root.dataset.enableStickyAnnouncementBar
  )
  setHeight()
  window.addEventListener('resize', setHeight)

  const syncInert = () => {
    const mobile = window.matchMedia('(max-width: 719px)').matches
    root.querySelectorAll('.announcement-bar__item-inner-desktop-only').forEach((el) => el.toggleAttribute('inert', mobile))
    root.querySelectorAll('.announcement-bar__item-inner-mobile-only').forEach((el) => el.toggleAttribute('inert', !mobile))
  }
  syncInert()
  window.matchMedia('(max-width: 719px)').addEventListener('change', syncInert)

  initFadeSlider(root)
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
